import React from 'react';
import ErrorComponent from '../components/ErrorComponent';

function Main({ showLogoutModal, setShowLogoutModal, message, onSuccess }) {
    return (
        <ErrorComponent 
            showLogoutModal={showLogoutModal} 
            setShowLogoutModal={setShowLogoutModal} 
            errorMessage={message}
            onSuccess={onSuccess}
        />
    );
}

export default Main;